import MultiColumnRowBase from './MultiColumnRowBase';

const ThreeColumnRow = ({ data, class_name, ...rest }) => {
	const className = class_name || 'col-md-4';
	if (!data.child_items) {
		// eslint-disable-next-line no-param-reassign
		data.child_items = [null, null, null];
		data.is_container = true;
	}
	return <MultiColumnRowBase {...rest} className={className} data={data} />;
};

export default ThreeColumnRow;
